<template>
  <div class="header-layout">
      <div class="default-win-width main">
          <div class="logo" @click="router.replace({name: 'main'})">
              <div class="h-first-img"/>
              <div class="h-second-img"/>
          </div>
          <sidebar-view/>
          <div class="lang">
              <v-menu v-model="menu" :close-on-content-click="false" location="end">
                  <template v-slot:activator="{ props }">
                      <div class="h-search-img cursor-pointer" v-bind="props"/>
                  </template>
                  <div style="background-color: white; max-width: 800px; width: 90%; max-height: 500px; overflow: hidden; padding: 10px; height: max-content; box-shadow: 0 0 20.7px 0 #00000017; display: flex; flex-direction: column; gap: 8px">
                      <div style="display: flex; flex-direction: row; gap: 6px">
                          <input v-model="searchText" placeholder="Поиск...">
                          <div @click="search(searchText)"
                               style="color: #1a1d1f;background: rgb(246, 246, 246); padding: 8px;  gap: 4px; border-radius: 8px; display: flex; flex-direction: row;align-items: center;cursor: pointer;position: relative;text-align: left;outline: none;">Поиск</div>
                      </div>
                      <div style="display: flex; flex-direction: column; gap: 6px; max-width: 500px; overflow: auto">
                          <v-virtual-scroll :items="posts" height="auto">
                              <template v-slot:default="{ item }">
                                  <div @click="item.action(); getAction()" style="cursor: pointer; padding: 4px 0">
                                      <v-icon style="padding-right: 4px">mdi-circle-medium</v-icon>
                                      {{ item.title }}
                                  </div>
                              </template>
                          </v-virtual-scroll>
                      </div>
                  </div>
              </v-menu>
              <lang-button/>
          </div>
      </div>
  </div>
</template>

<script setup>
import LangButton from "@/components/buttons/LangButton.vue";
import SidebarView from "@/components/sidebar/SidebarView.vue";
import {useRouter} from "vue-router";
import {SearchService} from "@/services/search.service";
import {ref} from "vue";

const searchService = new SearchService();
const router = useRouter();

let posts = ref([]);
let menu = ref(false)
let searchText = ref(null);
const search = (text) => {
    searchService.searchAll(text, 1, 10).then((res) => {
        posts.value = [
            ...res.posts.page.map(el => {
                el.action = () => router.push({name: 'newsDetails', params: {id: el.id}});
                return el;
            }),
            ...res.articles.page.map(el => {
                el.action = () => router.push({name: 'articleDetail', params: {category: el.categoryId, id: el.id}});
                return el;
            })
        ]
    }).catch(e => console.log(e));
}
const getAction = () => {
    menu.value = false;
    posts.value = [];
}
</script>

<style scoped lang="scss">
input{
    border-bottom: 1px solid rgba(200, 200, 200, 1);
    font-size: 16px;
    padding: 6px 12px;
    color: rgba(154, 158, 165, 1);
    width: 100%;
    &:focus{
        outline: none;
        border-color: #2F85FC;
        color: #2F85FC;
    }
}
</style>
